import { pathOr } from 'ramda';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';

import { entitiesStore } from 'modules/common/chat/entities/actions';

import partLibraryService from 'services/partLibraryService';

import { editTask, types } from './actions';
import { getTaskAssignmentDueDate, getTaskAssignmentUserId } from './reducer';

export default function* root() {
  yield takeEvery(types.EDIT_TASK_REQUEST, watchUpdateTask);
}

export function* getTaskAssignmentInfo() {
  const [assignedToId, dueDate] = yield all([
    select(getTaskAssignmentUserId),
    select(getTaskAssignmentDueDate),
  ]);

  if (assignedToId) {
    return {
      assignedToId,
      dueDate: dueDate.toISOString(),
    };
  } else {
    return undefined;
  }
}

function* watchUpdateTask(action) {
  try {
    const { assignedToId, dueDate, status, taskId } = action.payload;
    const response = yield call(partLibraryService.tasks.patch, taskId, {
      assignedToId,
      dueDate: dueDate ? dueDate.toISOString() : undefined,
      status,
    });

    yield put(entitiesStore.receiveTask(response));
    yield put(editTask.success({ taskId }));
  } catch (error) {
    yield put(
      editTask.error(error, pathOr(null, ['payload', 'taskId'], action)),
    );
  }
}
